import { render, staticRenderFns } from "./heatmap-2d.vue?vue&type=template&id=c307df06&"
import script from "./heatmap-2d.vue?vue&type=script&lang=js&"
export * from "./heatmap-2d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports